import { Action, createReducer, on } from '@ngrx/store'
import * as StageActions from './stage.actions'
import { User } from '@app/data/model/user.model'
import { KeycloakProfile } from 'keycloak-js'
import { InnplaceList } from '@app/data/model/innplaceList.model'

export interface SearchData {
   mode: string
   controls: any
   request: any
   page: number
   advancedOpen: boolean
}

const newSearchData = {
   mode: 'new',
   controls: {},
   request: {},
   page: 0,
   advancedOpen: false,
}

export interface PrefilterData {
   request: any
   page: number
}

const newPrefilterData = {
   request: {},
   page: 0,
}

export interface StageState {
   isMenuOpen: boolean
   breadcrumbs: any[]
   searchData: SearchData
   prefilterData: PrefilterData
   isPrivacyStatementAccepted: boolean | null
   userKc: KeycloakProfile
   user: User
   innplaceList: InnplaceList
}

export const initialState: StageState = {
   isMenuOpen: !(localStorage.getItem('menuOpen') == 'no'),
   breadcrumbs: [],
   searchData: newSearchData,
   prefilterData: newPrefilterData,
   isPrivacyStatementAccepted: null,
   userKc: undefined,
   user: undefined,
   innplaceList: null,
}

const stageReducer = createReducer(
   initialState,
   on(StageActions.openMenu, (state, action) => {
      localStorage.setItem('menuOpen', 'yes')
      return { ...state, isMenuOpen: true }
   }),
   on(StageActions.closeMenu, (state, action) => {
      localStorage.setItem('menuOpen', 'no')
      return { ...state, isMenuOpen: false }
   }),
   on(StageActions.addBreadcrumb, (state, action) => {
      return { ...state, breadcrumbs: [...state.breadcrumbs, action.breadcrumb] }
   }),
   on(StageActions.clearBreadcrumbs, (state, action) => {
      return { ...state, breadcrumbs: [] }
   }),
   on(StageActions.setSearchData, (state, action) => {
      return { ...state, searchData: { ...action.searchData } }
   }),
   on(StageActions.clearSearchData, (state, action) => {
      return { ...state, searchData: { ...newSearchData } }
   }),
   on(StageActions.setPrefilterData, (state, action) => {
      return { ...state, prefilterData: { ...state.prefilterData, ...action.prefilterData } }
   }),
   on(StageActions.clearPrefilterData, (state, action) => {
      return { ...state, prefilterData: { ...newPrefilterData } }
   }),
   on(StageActions.setPrivacyStatement, (state, action) => {
      return { ...state, isPrivacyStatementAccepted: action.privacyStatement }
   }),
   on(StageActions.setKcUser, (state, action) => {
      return { ...state, userKc: action.user }
   }),
   on(StageActions.setUser, (state, action) => {
      return { ...state, user: action.user }
   }),
   on(StageActions.loadInnplaceLists, (state, action) => {
      return { ...state, innplaceList: undefined }
   }),
   on(StageActions.loadInnplaceListsSuccess, (state, action) => {
      return { ...state, innplaceList: action.innplaceList }
   })
)

export function reducer(state: StageState | undefined, action?: Action) {
   return stageReducer(state, action)
}

